<template>
    <div>
        แลกหยวนเป็นบาท
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>